import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { scopeId: String }

  initialize() {
    this.imagesTabChange();
  }

  imagesTabChange() {
    const scope = this.hasScopeIdValue ? document.getElementById(this.scopeIdValue) : null;
    if (!scope) return;

    const activeTab = scope.querySelector("[data-tabs-target='tab']:not(.hidden)");
    if (!activeTab) return;

    const locale = activeTab.dataset.targetId.split("-")[1];

    scope.querySelectorAll(".translatable-image-tab").forEach(function (tab) {
      if (tab.id == `locale-image-${locale}`) {
        tab.classList.remove('hidden');
      } else {
        tab.classList.add('hidden');
      }
    });
  }
}